import arrow from './arrow';
import arrowUpRight from './arrow-up-right';
import checkMark from './check-mark';
import close from './close';
import expandMore from './expand-more';
import facebook from './facebook';
import instagram from './instagram';
import linkedin from './linkedin';
import planet from './planet';
import search from './search';
import twitter from './twitter';

export const arrowSvg = arrow;
export const facebookSvg = facebook;
export const twitterSvg = twitter;
export const linkedinSvg = linkedin;
export const instagramSvg = instagram;
export const expandMoreSvg = expandMore;
export const planetSvg = planet;
export const checkMarkSvg = checkMark;
export const arrowUpRightSvg = arrowUpRight;
export const closeSvg = close;
export const searchSvg = search;
